import { render, staticRenderFns } from "./TabelaTipoTrp.vue?vue&type=template&id=cd0abe22&scoped=true&"
import script from "./TabelaTipoTrp.vue?vue&type=script&lang=js&"
export * from "./TabelaTipoTrp.vue?vue&type=script&lang=js&"
import style0 from "./TabelaTipoTrp.vue?vue&type=style&index=0&id=cd0abe22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0abe22",
  null
  
)

export default component.exports